module.exports = __webpack_public_path__ + "img/Logius-logo.svg";